import { useCallback } from 'react';

export function useEntityPropertyChangedCallback<T, TKey extends keyof T>(
  obj: T,
  key: TKey,
  anyPropertyChanged: AnyPropertyChanged<T>
): (value: T[TKey]) => void {
  return useCallback(
    (value) => {
      anyPropertyChanged(obj, key, value);
    },
    [obj, key, anyPropertyChanged]
  );
}

export type AnyPropertyChanged<T> = <TKey extends keyof T>(
  obj: T,
  key: TKey,
  value: T[TKey]
) => void;
